import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

/** Rota legada: gestão de WhatsApp passou para Conexão (`/app/connection`). */
export default function WhatsAppPage() {
  const navigate = useNavigate();
  useEffect(() => {
    navigate("/app/connection", { replace: true });
  }, [navigate]);
  return (
    <div className="text-slate-500 text-sm p-6" data-testid="whatsapp-page-redirect">
      A redirecionar para Conexão…
    </div>
  );
}
